// Maharaj Ji's own account is featured separately (the Maharaj pages fetch it
// by name), so keep it out of the general astrologer lists. Match by email
// when the payload carries it; the public /astrologers reads omit email, so
// fall back to the id. Mirrors apps/website's AstrologersSection exclusion.
const EXCLUDED_EMAILS = ['rjn.bharti333@gmail.com']
const EXCLUDED_ID_FALLBACK = 15

export function isExcludedAstrologer(record) {
  const email = record?.email ?? record?.user?.email
  if (email) return EXCLUDED_EMAILS.includes(String(email).toLowerCase())
  return record?.id === EXCLUDED_ID_FALLBACK
}
